export default __webpack_public_path__ + "static/media/nasscom.becb0883.png";